import { EntityState } from '@reduxjs/toolkit';

/**
 * Query params for a base GET request with pagination, search and sort
 */
export interface BaseQueryParams {
  sort_by?: string;
  order_by?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
  search?: string;
  deleted?: boolean;
  includeArchived?: boolean;
  withHOS?: boolean; // this is just for get drivers api, maybe make a new interface for driver search
}

/**
 * Status for api calls
 */
export enum ApiStatus {
  IDLE = 'idle',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  PENDING = 'loading'
}

export interface PaginateResponse<T> {
  content: T[];
  total: number;
  more_records?: boolean;
}

export interface PaginateNormalizedResponse<T> {
  content: EntityState<T>;
  total: number;
  more_records?: boolean;
}

/**
 * Entity type to use for components that are shared
 *
 */
export enum EntityType {
  ORDER = 'ORDER',
  TRIP = 'TRIP'
}
